import { useRef, useState, useEffect } from "react";
import { Camera, Upload, X } from "lucide-react";
import CameraModal from "./CameraModal";

export default function DocumentCapture({ onAccept, dark = false, existingUrl = null }) {
  const fileRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [preview, setPreview] = useState(null);

  const canUseCamera = typeof navigator !== "undefined" && !!navigator.mediaDevices?.getUserMedia;

  useEffect(() => () => { if (preview) URL.revokeObjectURL(preview); }, [preview]);

  const select = (file) => {
    setPreview((prev) => { if (prev) URL.revokeObjectURL(prev); return URL.createObjectURL(file); });
    onAccept(file);
  };

  const openFile = (useCamera) => {
    if (useCamera) fileRef.current.setAttribute("capture", "environment");
    else fileRef.current.removeAttribute("capture");
    fileRef.current.click();
  };

  const onPick = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (file) select(file);
  };

  const text = dark ? "text-white/60" : "text-gray-500";
  const secondaryBtn = dark
    ? "bg-white/5 border border-white/15 text-white hover:bg-white/10"
    : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50";
  const frame = dark ? "border-white/15 bg-white/5" : "border-gray-200 bg-gray-50";
  const shownUrl = preview || existingUrl;

  return (
    <div className="space-y-3">
      <div className={`w-full aspect-[1.586] rounded-xl border overflow-hidden flex items-center justify-center ${frame}`}>
        {shownUrl ? (
          <img src={shownUrl} alt="Documento de identidad" className="w-full h-full object-contain" />
        ) : (
          <p className={`text-xs text-center px-4 ${text}`}>Aquí aparecerá la foto de tu documento</p>
        )}
      </div>

      <div className="flex flex-wrap gap-2">
        {canUseCamera ? (
          <button type="button" onClick={() => setShowCamera(true)}
            className={`px-4 py-2 rounded-xl text-sm font-semibold flex items-center gap-2 ${secondaryBtn}`}>
            <Camera size={15} /> Fotografiar documento
          </button>
        ) : (
          <button type="button" onClick={() => openFile(true)}
            className={`px-4 py-2 rounded-xl text-sm font-semibold flex items-center gap-2 ${secondaryBtn}`}>
            <Camera size={15} /> Tomar foto
          </button>
        )}
        <button type="button" onClick={() => openFile(false)}
          className={`px-4 py-2 rounded-xl text-sm font-semibold flex items-center gap-2 ${secondaryBtn}`}>
          <Upload size={15} /> Subir imagen
        </button>
        {preview && (
          <button type="button" onClick={() => { setPreview(null); onAccept(null); }}
            className={`px-3 py-2 rounded-xl text-sm font-semibold flex items-center gap-1 ${secondaryBtn}`}>
            <X size={14} /> Quitar
          </button>
        )}
      </div>

      <input ref={fileRef} type="file" accept="image/*" onChange={onPick} className="hidden" />

      <p className={`text-xs ${text}`}>Coloca el documento completo dentro del recuadro, con buena luz y sin reflejos.</p>

      {showCamera && (
        <CameraModal
          mode="document"
          onClose={() => setShowCamera(false)}
          onCapture={(file) => { setShowCamera(false); select(file); }}
        />
      )}
    </div>
  );
}
